import { LoginRadiusWidget, LRWidgetType } from './base';

export class RegistrationWidget extends LoginRadiusWidget<any, any> {
    constructor(container: string, lrObject: any) {
        super(container);
        this.widgetType = LRWidgetType.REGISTRATION;
        this.lrObject = lrObject;
    }
}
